/**
 * Application configuration constants
 * Single source of truth for app-wide settings
 */

// App version - update this when releasing new versions
// This should match the version in package.json
export const APP_VERSION = "1.4.5";

